
import NewComponent from "../../../components/ips/New.vue";

export default {
  components: {
    NewComponent
  }
};
